var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard-card", class: { highlight: _vm.highlight } },
    [
      _c(
        "div",
        { staticClass: "card-header" },
        [
          _c("a-icon", { staticClass: "card-icon", attrs: { type: _vm.icon } }),
          _vm._v(" "),
          _c("h4", { staticClass: "card-title" }, [_vm._v(_vm._s(_vm.title))]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card-content" }, [_vm._t("default")], 2),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }